module.exports = __webpack_public_path__ + "static/img/15.4e772a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/15.jpg
// module id = C/Bb
// module chunks = 1